import { Stack } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import StatusBadge from "../../../shared/components/common/ui/StatusBadge";
import TemplatePreviewCell from "../components/MessagePreview/TemplatePreviewCell";
import IconResolver from "../../../shared/components/common/ui/IconResolver";
import CostPreviewChip from "../components/MessagePricing/CostPreviewChip";

// helpers de largura (opcional, mas recomendado)
const compactCol = (extra = {}) => ({
  width: 80,
  sortable: false,
  filterable: false,
  ...extra,
});

const textCol = (extra = {}) => ({
  flex: 1,
  minWidth: 180,
  ...extra,
});

const mediumCol = (extra = {}) => ({
  flex: 1,
  minWidth: 220,
  ...extra,
});

const wideCol = (extra = {}) => ({
  flex: 1,
  minWidth: 360,
  ...extra,
});

export const getTemplatesColumns = (onOpenPricing) => [
  {
    field: "channel_type",
    headerName: "Canal",
    ...compactCol({
      renderCell: (params) => <IconResolver name={params.value} />,
    }),
  },

  {
    field: "title",
    headerName: "Nome",
    ...textCol(),
  },

  {
    field: "message_tag",
    headerName: "Categoria",
    ...textCol(),
  },

  {
    field: "cost_per_message",
    headerName: "Custo por mensagem",
    ...mediumCol({
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderHeader: () => (
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          onClick={(e) => {
            e.stopPropagation();
            onOpenPricing();
          }}
          sx={{ cursor: "pointer" }}
        >
          <span>Custo por mensagem</span>
          <InfoOutlinedIcon
            sx={{
              fontSize: 22,
              color: "rgb(0 0 0 / 60%)",
              "&:hover": { transform: "scale(1.1)" },
              transition: "all 0.2s",
            }}
          />
        </Stack>
      ),
      renderCell: (params) => {
        const { channel_type, message_meta_tier, status } = params.row;
        const isErrorStatus = String(status || "").toUpperCase() === "ERROR";
        const effectiveCostCategory =
          isErrorStatus
            ? "UNKNOWN"
            : message_meta_tier;

        return (
          <CostPreviewChip
            channelType={channel_type}
            costCategory={effectiveCostCategory}
          />
        );
      },
    }),
  },

  {
    field: "message_json",
    headerName: "Mensagem",
    ...wideCol({
      sortable: false,
      renderCell: (params) => <TemplatePreviewCell row={params.row} />,
    }),
  },

  {
    field: "status",
    headerName: "Status",
    ...textCol({
      renderCell: (params) => <StatusBadge status={params.value} />,
    }),
  },
];
